/**
 * Every dynamic import in the app, defined once.
 *
 * Both React.lazy (which renders a chunk) and the prefetcher (which warms it)
 * read from this object, so a split point cannot end up lazily loaded but
 * never prefetched -- which would reintroduce exactly the visible fallback
 * that splitting is supposed to be invisible about.
 *
 * Vite needs the import() specifier to be a literal it can see at build time,
 * so these stay as one thunk per chunk rather than anything parameterised.
 */
export const chunks = {
  login:              () => import('./pages/auth/Login'),
  register:           () => import('./pages/auth/Register'),
  instruments:        () => import('./pages/Instruments'),
  instrumentDetail:   () => import('./pages/InstrumentDetail'),
  instrumentMetrics:  () => import('./pages/InstrumentMetrics'),
  calculatedMetrics:  () => import('./pages/CalculatedMetrics'),
  deviceSetup:        () => import('./pages/DeviceSetup'),
  adminDashboard:     () => import('./pages/AdminDashboard'),
  adminAccountDetail: () => import('./pages/AdminAccountDetail'),
  adminUserDetail:    () => import('./pages/AdminUserDetail'),
  adminFleetOverview: () => import('./pages/AdminFleetOverview'),
  adminReingest:      () => import('./pages/AdminReingest'),
  adminBanner:        () => import('./pages/AdminBanner'),
  help:               () => import('./pages/Help'),
  settings:           () => import('./pages/Settings'),

  // Not a route. maplibre-gl is 939 KB minified (248 KB gzipped) and three
  // pages render a map, so without this it lands in a chunk shared by all of
  // them -- including the instrument list, which is the landing page for
  // every non-admin. Splitting the component out lets the page shell paint
  // first and the map arrive after.
  instrumentMap:      () => import('./components/InstrumentMap'),

  // A modal: never needed on first paint of the page that owns it.
  usageChartModal:    () => import('./pages/UsageChartModal'),
}
